import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { CheckOutTimeRenderer } from 'timeSheet/components/CellRenderers';

const useCheckOutColumn = ({
  updateCheckOutTime,
  hasActionPermission,
  updateOSCheckOutTime,
  allowUpdateExternal = false
}) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return CheckOutTimeRenderer({
        rowData: params.data,
        columnData: {
          updateCheckOutTime,
          updateOSCheckOutTime: allowUpdateExternal ? updateOSCheckOutTime : undefined,
          readOnly: !hasActionPermission,
          onOutsideClickSave: true,
          allowUpdateExternal
        }
      });
    },
    [updateCheckOutTime, updateOSCheckOutTime, hasActionPermission, allowUpdateExternal]
  );

  return useMemo(
    () => ({
      field: 'actualCheckOut',
      headerName: t('checkOutTime'),
      sortable: true,
      cellClass: 'justify-start',
      width: 125,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useCheckOutColumn;
